module.exports = __webpack_public_path__ + "img/kknn08.c715b5aa.jpg";